import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  appendQlubReturnFlag,
  buildQlubFallbackUrl,
  clearQlubReturnContext,
  getQlubReturnContext,
  isQlubReturnContextValid,
} from '../../utils/utils';

export const QlubReturn = () => {
  const navigate = useNavigate();
  const [noContext, setNoContext] = useState(false);

  useEffect(() => {
    const ctx = getQlubReturnContext();
    clearQlubReturnContext();

    if (isQlubReturnContextValid(ctx)) {
      window.location.replace(appendQlubReturnFlag(ctx.returnUrl, ctx.orderId));
    } else if (ctx?.idLoja) {
      navigate(buildQlubFallbackUrl(ctx.idLoja), { replace: true });
    } else {
      setNoContext(true);
    }
  }, [navigate]);

  if (noContext) {
    return (
      <div className="container padTop20" style={{ textAlign: 'center', minHeight: '350px' }}>
        <h4>Pagamento concluído</h4>
        <p>Não encontramos os dados da sua loja neste navegador.</p>
        <p>Escaneie o QR Code novamente e acesse o Menu e click em Meus Pedidos.</p>
      </div>
    );
  }

  return (
    <div className="container padTop20" style={{ textAlign: 'center', minHeight: '350px' }}>
      <p>Aguarde, retornando ao seu pedido...</p>
    </div>
  );
};
